import React from 'react'
import './splashscreen.sass'

export default function SplashScreen() {
    return (
        <div className="splashscreen"  >
            <img src={require('../../../assets/icons/lover_w.svg')} />
        </div>
    )
}
